//GENERAL ROUTES

const allLevels = ["company", "branch", "region", "group", "dealer"];

export const generalDashboard = {
  route: "Dashboard",
  path: "/dashboard",
  routeIcon: "home.svg",
  activeRouteIcon: "active-home.svg",
  children: [],
  name: ["dashboard"],
  view: ["station"],
  levels: allLevels,
};

export const propertyDashboardRoute = {
  route: "Dashboard",
  path: "/property-dashboard",
  routeIcon: "home.svg",
  activeRouteIcon: "active-home.svg",
  children: [],
  name: ["property-dashboard"],
  view: ["stationLease"],
  levels: allLevels,
};

export const staffDashboardRoute = {
  route: "Dashboard",
  path: "/staff-dashboard",
  routeIcon: "home.svg",
  activeRouteIcon: "active-home.svg",
  children: [],
  name: ["staff-dashboard"],
  view: ["staffManangement"],
  levels: allLevels,
};

export const maintenanceDashboardRoute = {
  route: "Dashboard",
  path: "/maintenance-dashboard",
  routeIcon: "home.svg",
  activeRouteIcon: "active-home.svg",
  children: [],
  name: ["maintenance-dashboard"],
  view: ["maintenance"],
  levels: allLevels,
};

export const drystockDashboardRoute = {
  route: "Dashboard",
  path: "/drystock-dashboard",
  routeIcon: "home.svg",
  activeRouteIcon: "active-home.svg",
  children: [],
  name: ["drystock-dashboard"],
  view: ["drystock"],
  levels: allLevels,
};

export const remisDashboardRoute = {
  route: "Dashboard",
  path: "/remis-dashboard",
  routeIcon: "home.svg",
  activeRouteIcon: "active-home.svg",
  children: [],
  name: ["remis-dashboard"],
  view: ["remis"],
  levels: allLevels,
};

export const dashboardRoutes = [
  generalDashboard,
  staffDashboardRoute,
  maintenanceDashboardRoute,
  drystockDashboardRoute,
  propertyDashboardRoute,
  remisDashboardRoute,
];
